import { makeAutoObservable, runInAction } from 'mobx';
import { IRootStore } from '../models/stores/root.models';
import { IUserEmailCode } from '../models/stores/user-email-code.models';
import { SupportBackendRoutes } from '../routes/backend.routes';
import { toast } from '../views/components/notification';

export class UserEmailCode implements IUserEmailCode {

  public readonly rootStore: IRootStore;

  public loading: boolean = false;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  public async getEmailCode(userId: string): Promise<void> {
    try {
      runInAction(() => {
        this.loading = true;
      });

      await this.rootStore.requests.text({
        method: 'GET',
        baseURL: this.rootStore.config.supportAPI,
        route: SupportBackendRoutes.getEmailCode,
        token: this.rootStore.user.token,
        params: {
          userId,
        },
      });
      toast({
        type: 'success',
        text: 'Сообщение на Email успешно отправлено.',
      });
      runInAction(() => {
        this.loading = false;
      });
    }
    catch (error) {
      runInAction(() => {
        this.loading = false;
        this.rootStore.errors.setError(error);
      });
    }
  }

}
